module.exports = __webpack_public_path__ + "static/img/whatToDo.22a6f675.png";